<div class="flex flex-center space-between bottom-spacer">
  <div class="heading-3 no-margin bold break-word">
    <ng-container *ngIf="modalType === 'payment'">{{ paymentModalTitle | translate }}</ng-container>
    <ng-container *ngIf="modalType === 'confirmRelease'">{{ 'general.api_cart_promoter_actions' | translate }}</ng-container>
    <ng-container *ngIf="modalType === 'confirmPrint'">{{ 'general.api_printing' | translate }}</ng-container>
    <ng-container *ngIf="modalType === 'sendEmail'">{{ 'general.api_cart_send_email_title' | translate }}</ng-container>
  </div>
  <div class="mobile align-right" *ngIf="modalType !== 'confirmPrint'">
    <button mat-button class="icon-button" (click)="closeModal()">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
</div>
<mat-card appearance="outlined" *ngIf="showDetailCard">
  <mat-card-content class="flex flex-column">
    <ng-container *ngIf="modalType === 'payment'">
      <ng-container *ngIf="!service.isSelfService" [ngTemplateOutlet]="ticketFormatChoice"></ng-container>
      <ng-container *ngIf="isCash">
        <app-numeric-input [type]="NumericInputType.Price" [label]="'general.api_cart_cash_amount'" [(value)]="cashAmount"></app-numeric-input>
        <ng-container *ngIf="cashAmount > 0">
          <ng-container *ngIf="cashAmountToReturn > 0">
            <app-info-message [message]="'general.api_cart_ask_for_more_amount'" [warning]="true" [large]="true"></app-info-message>
            <div class="heading-5 no-margin">{{ cashAmountToReturn | price }}</div>
          </ng-container>
          <ng-container *ngIf="cashAmountToReturn < 0">
            <app-info-message [message]="'general.api_cart_return_amount'" [icon]="'alert'" [color]="'text-grey'" [large]="true"></app-info-message>
            <div class="heading-5 no-margin">{{ cashAmountToReturn * -1 | price }}</div>
          </ng-container>
          <app-info-message *ngIf="cashAmountToReturn === 0" [message]="'general.api_cart_exact_amount'" [icon]="'success'" [color]="'text-success'" [large]="true"></app-info-message>
        </ng-container>
        <hr class="slim" *ngIf="!utilService.isMobile || !service.isSelfService">
      </ng-container>
      <ng-container *ngIf="!service.isSelfService">
        <ng-container [ngTemplateOutlet]="ticketPriceInfoChoice"></ng-container>
        <app-text-input [type]="TextInputType.Textarea" [label]="'general.api_transaction_internal_comment'" [(value)]="internalComment"></app-text-input>
      </ng-container>
      <div class="flex flex-column desktop">
        <ng-container [ngTemplateOutlet]="cartPaymentButtons"></ng-container>
      </div>
    </ng-container>

    <div class="flex flex-column" *ngIf="modalType === 'sendEmail'">
      <app-text-input [type]="TextInputType.Email" [label]="'general.api_cart_client_email'" [(value)]="clientEmail"></app-text-input>
      <app-info-message *ngIf="showPromoterIssueMessage" [message]="'general.api_cart_self_service_promoter_issue'"
                        [messageClass]="'top-spacer bottom-spacer'"></app-info-message>
      <div class="flex flex-column desktop">
        <ng-container [ngTemplateOutlet]="cartSendEmailButtons"></ng-container>
      </div>
    </div>

    <ng-container *ngIf="modalType === 'confirmRelease'">
      <ng-container [ngTemplateOutlet]="ticketFormatChoice"></ng-container>
      <ng-container [ngTemplateOutlet]="ticketPriceInfoChoice"></ng-container>
      <div class="flex flex-column">
        <ng-container [ngTemplateOutlet]="cartConfirmReleaseButtons"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="modalType === 'confirmPrint'">
      <div class="flex flex-column">
        <ng-container [ngTemplateOutlet]="cartConfirmPrintButtons"></ng-container>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
<footer class="mobile">
  <mat-dialog-actions class="flex flex-column">
    <ng-container *ngIf="modalType === 'payment'" [ngTemplateOutlet]="cartPaymentButtons"></ng-container>
    <ng-container *ngIf="modalType === 'confirmRelease'" [ngTemplateOutlet]="cartConfirmReleaseButtons"></ng-container>
    <ng-container *ngIf="modalType === 'sendEmail'" [ngTemplateOutlet]="cartSendEmailButtons"></ng-container>
    <ng-container *ngIf="modalType === 'confirmPrint'" [ngTemplateOutlet]="cartConfirmPrintButtons"></ng-container>
  </mat-dialog-actions>
</footer>
<!-- BUTTON SETS -->
<ng-template #cartPaymentButtons>
  <button mat-flat-button color="primary" (click)="checkoutCart.emit()"
          [disabled]="(isCash && isCashPaymentDisabled()) || !isValidClientNotificationEmail || disabledButtons">
    {{ (service.isSelfService ? 'general.api_cart_self_service_print' : 'general.api_payment_confirm') | translate }}
  </button>
  <button mat-stroked-button color="primary" *ngIf="ticketType === printTicketType.Pdf"
          (click)="modalType = 'sendEmail'; clientEmailChange.emit(service.clientNotificationEmail)"
          [disabled]="!isValidClientNotificationEmail || disabledButtons">
    {{ 'general.api_printing_send_to_email' | translate }}
  </button>
  <button mat-button (click)="cancelPayment.emit()" [disabled]="disabledButtons">
    {{ 'general.api_payment_cancel' | translate }}
  </button>
</ng-template>
<ng-template #cartSendEmailButtons>
  <button mat-flat-button color="primary"
          (click)="proceedTransaction.emit()"
          [disabled]="!isValidEmail(clientEmail) || disabledButtons">
    {{ 'general.api_cart_release_continue' | translate }}
  </button>
  <button mat-button (click)="modalType = 'payment'" [disabled]="disabledButtons">
    {{ 'general.api_cart_release_cancel' | translate }}
  </button>
</ng-template>
<ng-template #cartConfirmReleaseButtons>
  <button mat-flat-button color="primary" (click)="checkoutCart.emit()"
          [disabled]="authService.checkSalespointProperty('cart_cashback') && !cashAmount || disabledButtons">
    {{ 'general.api_printing_start' | translate }}
  </button>
  <button mat-stroked-button color="primary"
          *ngIf="ticketType === printTicketType.Pdf"
          (click)="modalType = 'sendEmail'"
          [disabled]="!isValidClientNotificationEmail || disabledButtons">
    {{ 'general.api_printing_send_to_email' | translate }}
  </button>
  <button mat-button (click)="cancelPayment.emit()" [disabled]="disabledButtons">
    {{ 'general.api_printing_cancel' | translate }}
  </button>
</ng-template>
<ng-template #cartConfirmPrintButtons>
  <button mat-flat-button color="primary" (click)="confirmPrinting.emit()">
    {{ 'general.api_printing_confirm' | translate }}
  </button>
  <button mat-stroked-button color="primary" *ngIf="!service.isSelfService" (click)="scrappingProcess.emit()">
    {{ 'general.api_printing_fail' | translate }}
  </button>
  <button mat-stroked-button color="primary" *ngIf="service.isSelfService" (click)="retryPrint.emit()">
    {{ 'general.api_printing_try_again' | translate }}
  </button>
</ng-template>
<ng-template #ticketFormatChoice>
  <app-label-value *ngIf="canChooseTicketFormat" [label]="'general.api_cart_ticket_format'"
                   [template]="ticketFormatTemplate" [withMargin]="true"></app-label-value>
  <ng-template #ticketFormatTemplate>
    <mat-radio-group class="flex flex-column" [(ngModel)]="ticketType" (ngModelChange)="ticketTypeChange.emit($event)">
      <mat-radio-button [value]="printTicketType.Plp">{{ 'general.api_cart_format_basic' | translate }}</mat-radio-button>
      <mat-radio-button [value]="printTicketType.Pdf">{{ 'general.api_cart_format_pdf' | translate }}</mat-radio-button>
    </mat-radio-group>
  </ng-template>
  <app-label-value *ngIf="authService.checkPrivileges(Privileges.TICKETS_PRINT_COUNT_BY) && ticketType === printTicketType.Pdf && service.hasMoreThanOneTicket" [label]="'general.api_cart_tickets_printed_count_by'"
                   [template]="ticketCountTemplate" [withMargin]="true"></app-label-value>
  <ng-template #ticketCountTemplate>
    <mat-form-field appearance="outline" class="max-width">
      <mat-select [(ngModel)]="ticketsPrintedCountBy" [ngModelOptions]="{standalone: true}"
                  [placeholder]="'general.api_cart_tickets_printed_count_by' | translate"
                  (selectionChange)="ticketsPrintedCountByChange.emit(ticketsPrintedCountBy)">
        <mat-select-trigger>{{('general.api_cart_tickets_printed_count_by_' + ticketsPrintedCountBy) | translate}}</mat-select-trigger>
        <mat-option [value]="'all'">{{ 'general.api_cart_tickets_printed_count_by_all' | translate }}</mat-option>
        <mat-option [value]="1">{{ 'general.api_cart_tickets_printed_count_by_1' | translate }}</mat-option>
        <mat-option [value]="2" *ngIf="service.ticketCount > 2">{{ 'general.api_cart_tickets_printed_count_by_2' | translate }}</mat-option>
        <mat-option [value]="3" *ngIf="service.ticketCount > 3">{{ 'general.api_cart_tickets_printed_count_by_3' | translate }}</mat-option>
        <mat-option [value]="4" *ngIf="service.ticketCount > 4">{{ 'general.api_cart_tickets_printed_count_by_4' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
</ng-template>
<ng-template #ticketPriceInfoChoice>
  <app-label-value *ngIf="service.canPrintWithoutPrice" [label]="'general.api_cart_print_tickets'"
                   [template]="printWithoutPriceTemplate" [withMargin]="true"></app-label-value>
  <ng-template #printWithoutPriceTemplate>
    <mat-radio-group class="flex flex-column" [(ngModel)]="priceInfo" (ngModelChange)="priceInfoChange.emit($event)">
      <mat-radio-button [value]="priceInfoEnum.Regular">{{ 'general.api_cart_print_tickets_regular' | translate }}</mat-radio-button>
      <mat-radio-button [value]="priceInfoEnum.Invitation">{{ 'general.api_cart_print_tickets_invitation' | translate }}</mat-radio-button>
      <mat-radio-button [value]="priceInfoEnum.None">{{ 'general.api_cart_print_tickets_without_price' | translate }}</mat-radio-button>
    </mat-radio-group>
  </ng-template>
</ng-template>
